Backbone = require 'vendor/backbone'
Auth = require 'db/auth'
_ = require 'underscore'
$ = require 'jquery'

# Backbone tries to read jquery off of `this` -- window in a cat world --
# but it's not set to something reasonable mid-require. So let's help it
# out a bit.
Backbone.$ = $

# Backbone tries to read jquery off of `this` -- window in a cat world --
# but it's not set to something reasonable mid-require. So let's help it
# out a bit.
Backbone.$ = require 'jquery'

Backbone.prepareData = (method, model, options = {}) ->
  tokenData =
    token: Auth.myToken()

  json =
    switch method
      when 'create', 'update'
        createJson =
          if options.requestData?
            # You can optionally send something completely different than the
            # model attributes via the requestData option
            _.clone(options.requestData)

          else if options.createData?
            # You can add to (or override parts of) the data that we send to
            # the server
            _.extend({}, model.toJSON(), options.createData)

          else
            _.clone(model.toJSON())

        # All creates/updates need to include the token as well
        _.extend(createJson, tokenData)
      when 'delete'
        tokenData
      else
        {}

  if method == 'read'
    if _.isArray(options.fields)
      json.fields = options.fields.join(',')

  if method == 'read'
    $.param(json)
  else
    JSON.stringify(json)

Backbone.syncOriginal = Backbone.sync

Backbone.sync = (method, model, options) ->
  switch method
    when 'update'
      # We can't trust Backbone to send updates; it wants to send all of the attributes
      # but we just want it to send things that have changed
      return options?.success?(model, {}, options)

    when 'create'
      # We have a problem where we get into a bad state if the notification of a create
      # arrives before the response to the API call is processed; because the model
      # hasn't been created yet, we don't know that the notification is giving us a
      # duplicate, so we can end up with two copies of the same model
      #
      # We attempt to solve this problem by locking the section of the model cache that
      # corresponds to the type of model that is being created; we won't process any
      # notifications for that type of model until after this API call is completed
      if !options.wait
        # We're not waiting for the server to respond, let's make sure notifications
        # don't get in the way
        lockIndex = model.modelCache.lock('Backbone.sync create')
        unlock = _.once -> model.modelCache.unlock(lockIndex)
        wrapWithUnlock = (fx) ->
          ->
            fx?(arguments...)
            unlock()

        # Automatically drop the lock after 10 seconds
        setTimeout wrapWithUnlock(), 10000

        options.success = wrapWithUnlock(options.success)
        options.error = wrapWithUnlock(options.error)

    when 'delete'
      if /^placeholder/.test(model.id)
        return

  Backbone.syncOriginal(arguments...)

module.exports = Backbone



// WEBPACK FOOTER //
// ./app/scripts/lib/backbone.coffee